import { type MetaFunction } from '@remix-run/node'
import productDisability from './product-disability.png'

export const meta: MetaFunction = () => [
	{ title: 'Disability Insurance' },
	{
		name: 'description',
		content: 'We offer disability insurance options.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Disability Insurance</h1>
			<img
				src={productDisability}
				alt="A young woman with crutches."
				className="rounded-lg object-cover object-center"
			/>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Life insurance
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Disability insurance
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				The duties of a breadwinner are twofold:
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				1. Bring home the bacon
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				2. Keep bringing home the bacon
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				You probably spent a lot of time learning and developing skills in order
				to land your dream job. If you lose the ability to work in your chosen
				industry due to an illness or injury, you would be able to receive a
				disability benefit from your disability policies.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				The importance of protecting your income stream
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Short and long term disability, including lump sum policies.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Individual policies, group policies, employer paid vs self paid and the
				tax consequences of each one.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				How will my rate be determined? The cost of this policy is determined
				primarily by the job classification - which is based on the type of
				labor that you perform and the likelihood that an injury will prevent
				you from being able to work in your industry. It is also heavily
				impacted by the amount of income that you are insuring for, the length
				of the benefit period, and waiting period. Disability policies almost
				always have a period of time following the disablement before the
				benefit starts to pay. The benefit period is how long the benefits last.
				Sometimes it is a lump sum benefit payable all at once, or it may
				provide for a percentage of lost income (for instance, if you have an
				income of $100,000 and the policy indicates that it covers 60% of income
				to age 65 with a 90 day waiting period, if you are injured at age 50 and
				are deemed disabled, your benefits would begin after the 90th day
				following the injury and pay 60% of the $100,000 (this will be split up
				into payments one or more times per month) until you recover from the
				injury or reach age 65.) Gender is also a determining factor in
				calculating the premium for a disability policy.
			</p>
		</main>
	)
}
